export default {
  office: {
    breadcrumbHome: 'Startseite',
    breadcrumbSolutions: 'Lösungen',
    breadcrumbCurrent: 'Büro & Praxis',
    hero: {
      eyebrow: 'Büro & Praxis',
      title: 'Diskrete Überwachung für Arbeitswelten',
      lead: 'Empfang, Flure, sensible Bereiche – wir planen Kamerasysteme, die schützen, ohne Mitarbeitende oder Patienten zu verunsichern.',
    },
    areas: {
      title: 'Einsatzbereiche in Büro und Praxis',
      lead: 'Moderne Büros und Praxen brauchen zurückhaltende Sicherheitstechnik. Wir integrieren Kameras dezent in die Architektur.',
      items: {
        '0': { title: 'Empfang', desc: 'Der erste Eindruck – und der erste Überwachungspunkt. Kameras am Empfang dokumentieren Besucher und sichern den Zugang.' },
        '1': { title: 'Flure & Gänge', desc: 'Lange Flure und Übergänge sind oft blinde Flecken. Kompakte Deckenkameras schließen die Lücken unauffällig.' },
        '2': { title: 'Besprechungsräume', desc: 'Nicht jede Besprechung muss aufgezeichnet werden. Wir richten Kameras so ein, dass nur die relevanten Bereiche erfasst werden.' },
        '3': { title: 'Serverraum & Technik', desc: 'Der Raum, in dem Ihre Daten liegen, verdient besondere Aufmerksamkeit. Zutritt und Aktivität werden zuverlässig protokolliert.' },
        '4': { title: 'Praxisempfang', desc: 'In Praxen zählt Diskretion. Wir montieren zurückhaltende Kameras, die Patienten nicht verunsichern – und sensible Zonen schützen.' },
        '5': { title: 'Parkplatz & Eingang', desc: 'Außenparkplätze und Eingänge sind nachts besonders gefährdet. Wetterfeste Kameras mit Nachtsicht behalten den Überblick.' },
      },
    },
    access: {
      eyebrow: 'Zutritt & Kontrolle',
      title: 'Wer darf was sehen?',
      lead: 'Ein Kamerasystem im Büro ist nur dann akzeptiert, wenn die Rechte klar geregelt sind. Wir richten differenzierte Zugriffsrechte ein und dokumentieren jede Nutzung.',
      items: {
        '0': { title: 'Benutzerverwaltung', desc: 'Jede Person erhält genau die Rechte, die sie braucht – von der Live-Ansicht bis zur Wiedergabe der Aufzeichnungen.' },
        '1': { title: 'Privatzonen-Maskierung', desc: 'Bereiche wie Pausenräume oder Umkleiden werden technisch ausgeblendet – direkt in Kamera oder Rekorder.' },
        '2': { title: 'Ereignis-Protokoll', desc: 'Wer hat wann was angesehen? Ein lückenloses Zugriffsprotokoll sorgt für nachvollziehbare Kontrolle.' },
      },
    },
    privacy: {
      eyebrow: 'Datenschutz',
      title: 'Datenschutz am Arbeitsplatz',
      lead: 'Beschäftigte und Besucher genießen besonderen Schutz. Wir setzen Ihre Überwachung so um, dass sie rechtskonform und fair bleibt – und beraten Sie bei der Dokumentation der Notwendigkeit.',
      list: {
        '0': 'Aufzeichnung nur dort, wo es betrieblich erforderlich ist',
        '1': 'Hinweisschilder für Mitarbeitende und Besucher anbringen',
        '2': 'Keine Überwachung von Umkleiden, Toiletten oder Pausenräumen',
        '3': 'Zugriff auf Aufzeichnungen nur für ausdrücklich Berechtigte',
        '4': 'Dokumentation der betrieblichen Notwendigkeit',
      },
      note: 'Hinweis: Die Überwachung von Arbeitsplätzen unterliegt strengen gesetzlichen Vorgaben. Wir beraten Sie technisch, ersetzen aber keine Rechtsberatung.',
    },
    cta: {
      title: 'Diskret. Datenschutzbewusst. Zuverlässig.',
      lead: 'Wir planen Ihr Büro- oder Praxissystem so, dass es schützt – und im Alltag niemanden stört. Unverbindlich und transparent.',
      primary: 'Beratungstermin vereinbaren',
      secondary: 'KameraPlaner starten',
    },
  },
};